import type { ExclusionAreaObservation } from '../../../types/apiModels'
import { apiClient } from '../client'
import endpoints from '../endpoints'
import { unwrapSingle } from '../normalize'

export type NewExclusionAreaObservation = {
  type: number
  comment: string
}

export const createObservation = async ({
  exclusionAreaId,
  data,
}: {
  exclusionAreaId: string
  data: NewExclusionAreaObservation
}): Promise<ExclusionAreaObservation> => {
  const response = await apiClient.post(
    endpoints.v2.exclusionAreas.observations(exclusionAreaId),
    data,
  )
  return unwrapSingle<ExclusionAreaObservation>(response)
}
